import SelectOption from '@/store/dict/selectOptionDict'
import { configFun } from './config.js'
import { getLeaseSchemeDetail } from '@/api/domain/leaseScheme'
import { MODE_TYPE } from '../const'

export default {
  data() {
    const {
      baseRules,
      configDefaultValue,
    } = configFun.call(this)
    return {
      baseRules,
      configDefaultValue,
      lessMonthCloumn: [
        {
          type: 'select',
          label: '日租金规则',
          key: 'dailyRule',
          source: SelectOption.dailyRentRules,
          options: {
            clearable: true,
            bottomText: '·首期租金以日租金乘以首期天数计算',
          },
        },
        {
          type: 'text',
          label: '尾期租金规则',
          key: 'lastPeriodRuleName',
        },
      ],
      fromPath: '',
      rentPeriodType: 'select',
      id: '',
      oLoading: {
        pageLoading: true,
        submit: false,
      },
      orderPlanFeeList: [],
      // 阶梯配置 默认两个阶梯
      ladderSchemeConfig: {
        isOpen: 0,
        unit: 1,
        clickNumber: 0,
        ladderSchemeList: [
          {
            startMonth: 1, // 开始时间为1
            endMonth: '',
            amount: '',
          },
          {
            startMonth: '',
            endMonth: '',
            amount: '',
          },
        ],
      },
      postParams: {}, // 提交表单数据
    }
  },
  // 利用路由钩子函数获取，此函数会在vue实列创建之前调用，故不能在此函数内调用this
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      vm.fromPath = from.path
    })
  },
  mounted() {
    this.pageConfig()
  },
  methods: {
    // 页面基本判断
    pageConfig() {
      setTimeout(() => {
        this.oLoading.pageLoading = false
      }, 1500)
      if (this.mode === MODE_TYPE.ADD) {
        return false
      }
      this.id = this.$route.query.id
      if (!this.id) {
        this.$message.error('url缺少ID参数')
        return false
      }
      this.getDetail()
    },
    async getDetail() {
      this.oLoading.submit = true
      try {
        const { code, data } = await getLeaseSchemeDetail({ id: this.id })
        if (code === 1) {
          this.setData(data)
        }
      } finally {
        this.oLoading.submit = false
      }
    },

    getJsonQuery() {
      let query
      try {
        query = JSON.parse(this.$route.query.redirectQuery)
      } catch (e) {
        query = null
      }
      return query
    },
    // 页面返回
    goPageBacks(status = false) {
      const { redirectPathName } = this.$route.query
      if (redirectPathName) {
        const _query = this.getJsonQuery()
        this.$refreshBack(status) // 关闭当前tab
        this.$router.push({
          name: redirectPathName,
          query: _query,
        })
      } else if (!this.fromPath || this.fromPath === '/') {
        this.$refreshBack(status) // 关闭当前tab
      } else {
        this.$refreshBack(status) // 关闭当前tab
        this.$router.push({
          path: this.fromPath,
          query: {
            id: this.id,
          },
        })
      }
    },
  },
}
